import {Pagination} from '../../../interfaces/pagination.interface';
import {OrderDetails} from '../../orders/data-access/interfaces/order-details.interface';

export interface SearchResponse {
  groups: SearchResponseGroup[];
  pagination: Pagination;
}

export interface SearchResponseGroup {
  filter: string;
  reports: OrderDetails[];
}

export enum SearchModalState {
  CLOSED = 'CLOSED',
  RESULTS = 'RESULTS',
  INFO = 'INFO',
  LOADING = 'LOADING',
  NO_RESULTS = 'NO_RESULTS',
}
